import "./services.css";

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { SERVICES, NON_PROFIT, ED_PROGRAM } from "../../data/content";
import { PAGE_ROUTES } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";
import { PageBanner } from "../general/PageParts";

const Services = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>OUR SERVICES | PM Skillshouse Foundation</title>
      </Helmet>
      <PageBanner title={"OUR SERVICES"} />

      <section className={"container services-list"}>
        {SERVICES.map((service, i) => (
          <Reveal
            key={service.id}
            as={"article"}
            id={service.id}
            className={`service-row ${i % 2 ? "is-orange" : ""}`}
          >
            <div>
              <h2 className={"service-title"}>{service.title}</h2>
              <p className={"service-tagline"}>{service.tagline}</p>
            </div>
            <p className={"service-text"}>{service.text}</p>
          </Reveal>
        ))}
      </section>

      <section
        className={"services-nonprofit parallax"}
        style={{ "--bg-image": "url(/images/services_banner.jpg)" }}
      >
        <Reveal className={"container"}>
          <h2>{NON_PROFIT}</h2>
        </Reveal>
      </section>

      <section
        className={"ed-program"}
        aria-label={"Enterprise Development Programme"}
      >
        {ED_PROGRAM.map((block, i) => (
          <div
            key={block.title}
            className={`ed-row ${i % 2 ? "is-flipped" : ""}`}
          >
            <div
              className={"ed-image"}
              style={{ backgroundImage: `url(${block.image})` }}
              role={"img"}
              aria-label={block.imageAlt}
            />
            <Reveal className={"ed-text"}>
              <h2>{block.title}</h2>
              {block.intro && <p>{block.intro}</p>}
              <ul>
                {block.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </Reveal>
          </div>
        ))}
      </section>

      <section className={"services-cta"}>
        <div className={"container"}>
          <h2>Ready to take your business to the next level?</h2>
          <Link
            to={PAGE_ROUTES.CONTACT}
            className={"btn btn-orange"}
          >
            CONTACT US
          </Link>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Services;
